<template>
  <div class="delivery-collection-kpi-main">
    <div class="left-container">
      <div class="date-section">
        <div style="flex-grow: 1;">
          <span>Movement Date</span>  
          <DateTimePicker placeholder="From" :showTime="false" :value.sync="fromDate" :isRequired="true" :errorMessage.sync="fromDateError" />
          <DateTimePicker placeholder="To" :showTime="false" :value.sync="toDate" :isRequired="true" :errorMessage.sync="toDateError" />
        </div>

        <button @click="refreshClicked">Refresh</button>
      </div>

      <Dropdown style="margin: 10px 0" placeholder="System" :items="systemItems" itemKey="Application Name" :selectedObject.sync="selectedSystem"
        :isRequired="true" :errorMessage.sync="systemError" />

      <div class="filter-table">
        <Filters class="customer-filter" title="Customer" :tableData="customerData" itemKey="Customer Code" itemDesc="Customer Name" @confirmClicked="filterCustConfirm"/>
        <Filters class="jobtype-filter" title="JobType" :tableData="jobData" itemKey="Job Type" itemDesc="Description" @confirmClicked="filterJobConfirm"/>
        <Filters class="haulier-filter" title="Haulier" :tableData="haulierData" itemKey="Haulier Code" itemDesc="Description" @confirmClicked="filterHaulierConfirm"/>
      </div>
    </div>

    <div class="right-container">
      <div class="filtered-section">
        <div class="filtered-items">
          <div class="filtered-row">
            <div class="filter-title">Job Date</div>
            <div class="colon-separator">:</div>
            <div class="filter-details">{{ fromDateInfo }} to {{ toDateInfo }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">System</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredSystem ? filteredSystem.System : ''">{{ filteredSystem ? filteredSystem.System : '' }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">Customer</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredCustomer.length == 0 ? 'All' : filteredCustomer.map((s) => { return s['Customer Code'] }).join(', ')">{{ filteredCustomer.length == 0 ? 'All' : filteredCustomer.map((s) => { return s['Customer Code'] }).join(',') }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">Job Type</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredJobType.length == 0 ? 'All' : filteredJobType.map((s) => { return s['Job Type'] }).join(', ')">{{ filteredJobType.length == 0 ? 'All' : filteredJobType.map((s) => { return s['Job Type'] }).join(',') }}</div>
          </div>
          <div class="filtered-row">
            <div class="filter-title">Haulier</div>
            <div class="colon-separator">:</div>
            <div class="filter-details" :title="filteredHaulier.length == 0 ? 'All' : filteredHaulier.map((s) => { return s['Haulier Code'].split(' ').join('') }).join(', ')">{{ filteredHaulier.length == 0 ? 'All' : filteredHaulier.map((s) => { return s['Haulier Code'].split(' ').join('') }).join(',') }}</div>
          </div>
        </div>
        <div class="refresh-section">
          <div v-if="refreshDate">Last Refreshed : {{refreshDate}}</div>
        </div>
      </div>

      <div class="delivery-chart-table">
        <div class="delivery-title">On Time Delivery KPI</div>
        <div class="delivery">
          <div class="delivery-chart-container">
            <div class="delivery-chart" id="del-chart"> </div>
          </div>
          <div class="delivery-chart-legend-DC" id="legend"></div>
        </div>
      </div>

      <div class="collection-chart-table">
        <div class="collection-title">On Time Collection KPI</div>
        <div class="collection">
          <div class="collection-chart-container">
            <div class="collection-chart" id="col-chart"></div>
          </div>
          <div class="collection-chart-legend-DC" id="legend2"></div>
        </div>
      </div>
    </div>

    <ContextMenu v-if="showContextMenu" :show.sync="showContextMenu" :position="contextPosition" :contextItems="contextItems"
      @contextSelected="contextSelected" ref="context"/>
  </div>
</template>

<script>
/* eslint-disable */
import Filters from '@/components/Filters.vue';
import ContextMenu from '@/components/ContextMenu.vue';

export default {
  components: {
    Filters, ContextMenu
  },
  data: function() {
    return {
      fromDate: new Date(new Date().getFullYear(), 0, 1), // first day of current year
      toDate: new Date( // last day of current month
        new Date().getFullYear(),
        new Date().getMonth() + 1,
        0
      ),
      fromDateError: '',
      toDateError: '',
      fromDateInfo: null,
      toDateInfo: null, 
      refreshDate: "", // date formatted into a string, updated in refreshClicked()

      systemItems: [],
      systemError: '',
      selectedSystem: null,
      filteredSystem: null,

      customerData: [],
      jobData: [],
      haulierData: [],

      selectedCustomer: [],
      filteredCustomer: [],

      selectedJobType: [],
      filteredJobType: [],

      selectedHaulier: [],
      filteredHaulier: [],

      delChartData: [],
      colChartData: [],
      delChart: null,
      colChart: null,
      
      showContextMenu: false,
      contextItems: ['On Time [RptType] KPI'],
      contextPosition: [100, 100],
    };
  },
  props: {
  },
  methods: {
    drillThroughClicked: async function(rptType) {
      this.$fullscreenLoading('Getting details');

      var dataToPost = {
        'startdate': this.fromDate.formatString('yyyy-MM-dd'),
        'startdate': this.fromDate.formatString('yyyy-MM-dd'),
        'enddate': this.toDate.formatString('yyyy-MM-dd'),
        'rpttype': rptType,
        'system': this.filteredSystem.System,
        'jobtypearray': this.filteredJobType.map((s) => { return s['Job Type'] }).join(', '),
        'customerarray': this.filteredCustomer.map((s) => { return s['Customer Code'] }).join(', '),
        'haulierarray': this.filteredHaulier.map((s) => { return s['Haulier Code'] }).join(', '),
      }

      sessionStorage.setItem(`Drill Through - ${rptType == 'DEL_JOB' ? 'DEL_JOB' : 'COL_JOB'}`, JSON.stringify({ data: dataToPost }));
      var drillThroughLink = this.$router.resolve(`/Home/${this.$route.params['user']}/Dashboard/Delivery & Collection KPI/Drill Through - ${rptType == 'DEL_JOB' ? 'DEL_JOB' : 'COL_JOB'}`);
      window.open(drillThroughLink.href, '_blank');
    
      this.$fullscreenLoading();
    },
    contextSelected: function(item) {
      this.drillThroughClicked(item.includes('Delivery') ? 'DEL_JOB' : 'COL_JOB');
    },
    filterCustConfirm: function(items) {
      this.selectedCustomer = items;
    },
    filterJobConfirm: function(items) {
      this.selectedJobType = items;
    },
    filterHaulierConfirm: function(items) {
      this.selectedHaulier = items;
    },
    checkError: function() {
      var errorCount = 0;

      if (!this.fromDate) {
        errorCount++;
        this.fromDateError = "From date is required!";
      }

      if (!this.toDate) {
        errorCount++;
        this.toDateError = "To date is required!";
      }

      if (!this.selectedSystem) {
        errorCount++;
        this.systemError = 'System is required!';
      }

      return errorCount == 0;
    },
    refreshClicked: async function() {
      if (!this.checkError()) {
        return;
      }

      $('#del-chart').html('');
      $('#col-chart').html('');
      $('#legend').html('');
      $('#legend2').html('');

      this.createChart();
      
    },
    createChart: async function() {
      this.fromDateInfo = this.fromDate.formatString('yyyy-MM-dd');
      this.toDateInfo = this.toDate.formatString('yyyy-MM-dd');
      this.refreshDate = (new Date()).formatString('dd/MM/yyyy HH:mm');

      this.filteredSystem = this.selectedSystem;

      this.filteredCustomer = this.selectedCustomer;
      var getCustomerCode = this.filteredCustomer.length == 0 ? '' : this.filteredCustomer.map((c) => { return c['Customer Code'] }).join(',');

      this.filteredJobType = this.selectedJobType;
      var getJobType = this.filteredJobType.length == 0 ? '' : this.filteredJobType.map((c) => { return c['Job Type'] }).join(',');

      this.filteredHaulier = this.selectedHaulier;
      var getHaulierCode = this.filteredHaulier.length == 0 ? '' : this.filteredHaulier.map((c) => { return c['Haulier Code'] }).join(',');
      getHaulierCode = getHaulierCode.split(' ').join('');

      this.$fullscreenLoading('Getting DelColOnTime Analysis');
      this.delChartData = await this.$apiCallV2(`/DeliveryCollectionKpi/GetDelColOnTimeAnalysis?start=${this.fromDate.formatString('yyyy-MM-dd')}
        &end=${this.toDate.formatString('yyyy-MM-dd')}&rptType=DEL_MONTH&sys=${this.filteredSystem['System']}
        &jobtypeArray=${getJobType}&custArray=${getCustomerCode}&haulArray=${getHaulierCode}`);

      this.colChartData = await this.$apiCallV2(`/DeliveryCollectionKpi/GetDelColOnTimeAnalysis?start=${this.fromDate.formatString('yyyy-MM-dd')}
        &end=${this.toDate.formatString('yyyy-MM-dd')}&rptType=COL_MONTH&sys=${this.filteredSystem['System']}
        &jobtypeArray=${getJobType}&custArray=${getCustomerCode}&haulArray=${getHaulierCode}`);
      this.$fullscreenLoading();

      if(this.delChartData.includes('error'))
        document.getElementById('del-chart').innerHTML = "<div style=\"text-align: center; font-size: 12px; font-weight: bold; width: calc(100% + 150px);\">An error occurred. Please try again.</div>";
      else if(this.delChartData.length == 0)
        document.getElementById('del-chart').innerHTML = "<div style=\"text-align: center; font-size: 12px; font-weight: bold; width: calc(100% + 150px);\">No records found.</div>";
      else{
        var dynamicSeriesName = Object.keys(this.delChartData[0]).filter((o) => { return o != 'XAxis' && o != 'XAxisDesc'})
        var percentageName = dynamicSeriesName.filter(function (str) { return str.includes('Perc') });
        var dynamicSeriesName = dynamicSeriesName.filter(function (str) { return !str.includes('Perc') });
        
        var dynamicSeries = dynamicSeriesName.map((d) => {
          return {
            name: d,
            data: this.delChartData.map((p) => { return p[d] }),
          }
        });

        var perc = percentageName.map((d) => { return this.delChartData.map((p) => { return p[d] })})
        var firstIndex = 0;
        var secondIndex = 0;
        var limit = perc[0].length;
        var count = limit * perc.length;
        
        var someDiv = document.getElementById('legend');
        var countExecute = 0;
        this.delChart = new Chartist.Bar('.delivery-chart', {
          labels: this.delChartData.map((p) => { return p['XAxisDesc'] }),
          series: dynamicSeries
        }, {
          chartPadding: {top: 50},
          seriesBarDistance: 20,
          plugins: [ 
            Chartist.plugins.legend( { position: someDiv, clickable: false, className: "delivery-DC" } ),
            Chartist.plugins.ctAxisTitle({
              axisY: {
                axisTitle: 'Total Containers',
                axisClass: 'ct-axis-title',
              }
            }),
            Chartist.plugins.ctBarLabels({
              labelClass: 'ct-label-del',
              labelOffset: {
                y: -20
              },
              showZeroLabels: true,
              labelInterpolationFnc: function(value) {
                if(countExecute == count){
                  countExecute = 0;
                  firstIndex = 0;
                  secondIndex = 0;
                }

                if (secondIndex == limit) {
                  firstIndex++;
                  secondIndex = 0;
                }

                countExecute++;
                return perc[firstIndex][secondIndex++] + "%";
              }
            })
          ] 
        } ) ;
      }

      if(this.colChartData.includes('error'))
        document.getElementById('col-chart').innerHTML = "<div style=\"text-align: center; font-size: 12px; font-weight: bold; width: calc(100% + 150px);\">An error occurred. Please try again.</div>";
      else if(this.colChartData.length == 0)
        document.getElementById('col-chart').innerHTML = "<div style=\"text-align: center; font-size: 12px; font-weight: bold; width: calc(100% + 150px);\">No records found.</div>";
      else{
        var dynamicSeriesName2 = Object.keys(this.colChartData[0]).filter((o) => { return o != 'XAxis' && o != 'XAxisDesc'})
        var percentageName2 = dynamicSeriesName2.filter(function (str) { return str.includes('Perc') });
        var dynamicSeriesName2 = dynamicSeriesName2.filter(function (str) { return !str.includes('Perc') });
        var dynamicSeries2 = dynamicSeriesName2.map((d) => {
          return {
            name: d,
            data: this.colChartData.map((p) => { return p[d] })
          }
        });

        var perc2 = percentageName2.map((d) => { return this.colChartData.map((p) => { return p[d] })})
        var firstIndex2 = 0;
        var secondIndex2 = 0;
        var limit2 = perc2[0].length;
        var count2 = limit2 * perc2.length;

        var someDiv2 = document.getElementById('legend2');
        var countExecute2 = 0;
        this.colChart = new Chartist.Bar('.collection-chart', {
          labels: this.colChartData.map((p) => { return p['XAxisDesc'] }),
          series: dynamicSeries2
        }, {
          chartPadding: {top: 50},
          seriesBarDistance: 20,
          plugins: [ 
            Chartist.plugins.legend( { position: someDiv2, clickable: false, className: "collection-DC" } ),
            Chartist.plugins.ctAxisTitle({
              axisY: {
                axisTitle: 'Total Containers',
                axisClass: 'ct-axis-title',
              }
            }),
            Chartist.plugins.ctBarLabels({
              labelClass: 'ct-label-col',
              labelOffset: {
                y: -20
              },
              showZeroLabels: true,
              labelInterpolationFnc: function(value) {
                if(countExecute2 == count2){
                  countExecute2 = 0;
                  firstIndex2 = 0;
                  secondIndex2 = 0;
                }

                if (secondIndex2 == limit2) {
                  firstIndex2++;
                  secondIndex2 = 0;
                }

                countExecute2++;
                return perc2[firstIndex2][secondIndex2++] + "%";
              }
            })
          ] 
        } );
      }

      var formatCurrency = new Intl.NumberFormat();
      var $tooltip = $('<div class="tooltip tooltip-hidden"></div>').appendTo($('.delivery-chart'));
      $(document).on('mouseenter', '.ct-bar', function() {
        var seriesName = $(this).closest('.ct-series').attr('ct:series-name'), value = $(this).attr('ct:value');

        $tooltip.html("<span>" + seriesName + "<br/> " + formatCurrency.format(value) + "</span>");
        $tooltip.removeClass('tooltip-hidden'); 
      });

      $(document).on('mouseleave', '.ct-bar', function() {
        $tooltip.addClass('tooltip-hidden');
      });

      $(document).on('mousemove', '.ct-bar', function(event) {
        $tooltip.css({
          left: event.pageX - 35,
          top: event.pageY - 100
        });
      });

      var $tooltip2 = $('<div class="tooltip tooltip-hidden"></div>').appendTo($('.collection-chart'));
      $(document).on('mouseenter', '.ct-bar', function() {
        var seriesName = $(this).closest('.ct-series').attr('ct:series-name'), value = $(this).attr('ct:value');

        $tooltip2.html("<span>" + seriesName + "<br/> " + formatCurrency.format(value) + "</span>");
        $tooltip2.removeClass('tooltip-hidden');
      });

      $(document).on('mouseleave', '.ct-bar', function() {
        $tooltip2.addClass('tooltip-hidden');
      });

      $(document).on('mousemove', '.ct-bar', function(event) {
        $tooltip2.css({
          left: event.pageX - 35,
          top: event.pageY - 100
        });
      });

      var mainContainer = this;
      $('#del-chart').ready(() => {
        $('#del-chart').on('click', '.ct-bar', function(e) {
          mainContainer.showContextMenu = true;
          mainContainer.contextItems = [ 'On Time Delivery KPI'];
          
          mainContainer.$nextTick(() => {
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 35), e.clientX + 15];
          });
        });
      });

      $('#col-chart').ready(() => {
        $('#col-chart').on('click', '.ct-bar', function(e) {
          mainContainer.showContextMenu = true;
          mainContainer.contextItems = [ 'On Time Collection KPI'];
          
          mainContainer.$nextTick(() => {
            mainContainer.contextPosition = [ e.clientY - (mainContainer.$refs.context.$el.clientHeight - 35), e.clientX + 15];
          });
        });
      });

    }
  },
  async mounted() {
    this.$fullscreenLoading('Getting Systems');
    var system = await this.$apiCallV2('/DeliveryCollectionKpi/GetListMaster?masterFile=SYSTEM');
    this.systemItems = system;
    this.selectedSystem = this.systemItems[0];

    this.$fullscreenLoading('Getting Customers');
    var cust = await this.$apiCallV2('/DeliveryCollectionKpi/GetListMaster?masterFile=BILLCUSTNAME');
    this.customerData = cust;

    this.$fullscreenLoading('Getting Job Types');
    var job = await this.$apiCallV2(`/DeliveryCollectionKpi/GetListMaster?masterFile=jobtype&mod=${this.selectedSystem['System']}`);
    this.jobData = job;

    this.$fullscreenLoading('Getting Haulier');
    var hau = await this.$apiCallV2('/DeliveryCollectionKpi/GetListMaster?masterFile=HAULIER');
    this.haulierData = hau;

    this.$fullscreenLoading();

    this.createChart();
  },
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.delivery-collection-kpi-main{
  display: flex;
  padding: 5px 45px;
  width: 100%;
  height: 100%;
  font-size: 12px;

  > .left-container{
    height: 100%;
    min-width: 300px;
    max-width: 300px;
    padding: 5px;
    background-color: white;
    border-radius: 5px;
    margin-right: 5px;

    > .date-section{
      height: 80px;
      display: flex;
      align-items: center;
    }
    
    > .filter-table{
      width: 100%; 
      height: calc( 100% - 125px); 
      flex-grow: 1;

      >.customer-filter{
        width: 100%; 
        height: calc( 100% - 67%);
      }

      >.jobtype-filter{
        width: 100%; 
        height: 33%; 
      }

      >.haulier-filter{
        width: 100%; 
        height: 33%;  
      }
    }
  }

  > .right-container{
    width: 100%;
    height: 100%;

    > .filtered-section {
      width: 100%;  
      height: calc(100% - 85%);
      background-color: white;
      border-radius: 5px;
      padding: 5px;
      position: relative;
      display: flex;
      align-items: center;
      margin-bottom: 3px;

      > .filtered-items {
        width: calc(100% - 250px);

        > .filtered-row {
          display: flex;
          align-items: center;

          > .filter-title {
            width: 70px;
          }

          > .colon-separator {
            margin: 0 5px;
          }

          > .filter-details {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      
      > .refresh-section {
        height: 100%;
        min-width: 250px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }

    > .delivery-chart-table{
      width: 100%;
      height: calc(100% - 57.5% );
      background-color: white;
      border-radius: 5px;
      padding: 5px;
      margin-bottom: 3px;

      > .delivery-title{
        width: 100%;
        height: 25px;
        text-align: center;
        font-weight: bold;
      }

      > .delivery{
        width: 100%;
        height: calc(100% - 25px);
        display: flex;

        > .delivery-chart-container{
          width: calc(100% - 150px);
          height: 100%;

          > .delivery-chart{
            width: 100%;
            height: 100%;
          }
        }

        > .delivery-chart-legend-DC{
          width: 150px;
          height: 100%;
          padding: 100px 0;
        }
      }
    }

    > .collection-chart-table{
      width: 100%;
      height: calc(42.5% - 6px);
      background-color: white;
      border-radius: 5px;
      padding: 5px;
      margin-top: 3px;

      > .collection-title{
        width: 100%;
        height: 25px;
        text-align: center;
        font-weight: bold;
      }

      > .collection{
        width: 100%;
        height: calc(100% - 25px);
        display: flex;

        > .collection-chart-container{
          width: calc(100% - 150px);
          height: 100%;

          > .collection-chart{
            width: 100%;
            height: 100%;
          }
        }

        > .collection-chart-legend-DC{
          width: 150px;
          height: 100%;
          padding: 100px 0;
        }
      }
    }
  }
}
</style>